import React, { useCallback } from 'react';
import { Item, Spacer, View } from './styles';
import { CardContent, Typography, Stack, Link, useTheme } from '@mui/material';
import { contractManagement } from '../../services/utils/axios';
import { useAuth } from '../../services/contexts/AuthContext';
import { useSWRConfig } from 'swr';
import { useTranslation } from 'react-i18next';
import { getUserTypeData } from '../../services/utils/translations-constants.js';
import OverflowText from '../../components/OverflowText';
export default function UserComponent({
  contract,
  setErrorLabel,
  setSuccessLabel,
}) {
  const { t } = useTranslation();
  const { userTypeMap } = getUserTypeData(t);
  // added two labels to handle error and success
  const { token } = useAuth();
  const { mutate } = useSWRConfig();

  const dbKommunikationsadresse = contract
    ? [
        contract?.contractAddress?.careOf
          ? `c/o ${contract?.contractAddress?.careOf} `
          : '',
        contract?.contractAddress?.street + ' ',
        contract?.contractAddress?.zipCode +
          ' ' +
          contract?.contractAddress?.city,
      ]
    : null;

  const dbRechnungsnschrift = contract
    ? contract?.useCustomBillingDetails
      ? [
          contract?.contractBillingAddress?.name + ', ',
          contract?.contractBillingAddress?.careOf
            ? `c/o ${contract?.contractBillingAddress?.careOf} `
            : '',
          contract?.contractBillingAddress?.street + ' ',
          contract?.contractBillingAddress?.zipCode +
            ' ' +
            contract?.contractBillingAddress?.city,
        ]
      : [
          contract?.firstName + ' ' + contract?.lastName + ', ',
          dbKommunikationsadresse,
        ]
    : null;

  const nutzer = {
    Kundennummer: contract?.endCustomerId,
    Name:
      contract?.firstName &&
      `${contract?.firstName + ' ' + contract?.lastName}`,
    Kommunikationsadresse: dbKommunikationsadresse,
    Rechnungsnschrift: dbRechnungsnschrift,
    EMail: contract?.email,
    billingEmail: contract?.billingEmail,
    UserType: userTypeMap[contract?.userType] || contract?.userType,
    ContractNumber: contract?.contractNumber,
  };
  const renderKey = useCallback(
    (key) => {
      switch (key) {
        case 'EMail':
          return 'E-Mail';
        case 'billingEmail':
          return t('billingEmail');
        case 'Kundennummer':
          return t('LBLCustomerNum');
        case 'Kommunikationsadresse':
          return t('communicationadr');
        case 'Rechnungsnschrift':
          return t('billingadr');
        case 'UserType':
          return t('LBLUserType');
        case 'ContractNumber':
          return t('ContractNumberLBL');
        default:
          return key;
      }
    },
    [contract]
  );
  const handleClick = async (e) => {
    e.preventDefault();
    try {
      await contractManagement.post(
        `/send-invitation-email/${contract?.contractKey}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      mutate([
        `/send-invitation-email/${contract?.contractKey}`,
        token,
        'contractManagement',
      ]);
      setSuccessLabel(true);
    } catch (error) {
      setErrorLabel(true);
    }
  };
  const { status } = useTheme();
  return (
    <View>
      <CardContent>
        <Typography fontWeight="bold" variant="h4" gutterBottom>
          {t('LBLUserInfo')}
        </Typography>
        <Spacer mb={4} />
        <Typography variant="body2" component="div" gutterBottom>
          {nutzer && (
            <>
              {Object.entries(nutzer)
                .filter(
                  ([_, value]) =>
                    value !== null && value !== '' && value !== undefined
                )
                .map(([key, value]) => {
                  return (
                    <>
                      {renderKey(key) && (
                        <>
                          <Item key={key}>
                            <Typography fontWeight="fontWeightMedium">
                              {renderKey(key)}
                            </Typography>
                            {key === 'Status' ? (
                              contract?.contractStatus == 'CREATED_UNSIGNED' ? (
                                <Stack
                                  size="small"
                                  mr={1}
                                  mb={1}
                                  color={status[value.toLowerCase()]}
                                >
                                  <Link
                                    color="text.secondary"
                                    href="#"
                                    aria-describedby="ContactComponent-popover"
                                    onClick={handleClick}
                                  >
                                    {value} (Einladungsmail erneut senden?)
                                  </Link>
                                </Stack>
                              ) : (
                                <Typography
                                  size="small"
                                  mr={1}
                                  mb={1}
                                  color={status[value.toLowerCase()]}
                                >
                                  {value}
                                </Typography>
                              )
                            ) : key === 'Kommunikationsadresse' ||
                              key === 'Rechnungsnschrift' ? (
                              <Typography
                                fontWeight="fontWeightRegular"
                                align="right"
                              >
                                <OverflowText
                                  label={value}
                                  maxwidthValue={'250px'}
                                >
                                  {' '}
                                </OverflowText>
                              </Typography>
                            ) : (
                              <Typography
                                fontWeight="fontWeightRegular"
                                align="right"
                              >
                                {['string', 'number'].includes(typeof value)
                                  ? value
                                  : value?.join(', ') || null}
                              </Typography>
                            )}
                          </Item>
                        </>
                      )}
                    </>
                  );
                })}
            </>
          )}
        </Typography>
      </CardContent>
    </View>
  );
}
